// Compact image gallery for the homepage product spotlight.
// Markup: [data-track] (horizontal scroll-snap row of slides) + [data-thumb] buttons (data-index).
// Thumbnails scroll the track to their slide; swiping the track updates the active thumbnail (aria-current).
class MiniGallery extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.track = this.querySelector('[data-track]');
    this.thumbs = [...this.querySelectorAll('[data-thumb]')];
    if (!this.track) return;

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        // Tapping the active thumbnail again returns to the main photo.
        const index = Number(thumb.dataset.index);
        this.#go(thumb.getAttribute('aria-current') === 'true' ? 0 : index);
      }, opts);
    });

    let frame;
    this.track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => this.#sync());
    }, { ...opts, passive: true });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #go(index) {
    const slide = this.track.children[index];
    if (!slide) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    this.#setActive(index);
  }

  #sync() {
    const width = this.track.clientWidth || 1;
    const index = Math.round(Math.abs(this.track.scrollLeft) / width);
    this.#setActive(index);
  }

  #setActive(index) {
    this.thumbs.forEach((thumb) => {
      if (Number(thumb.dataset.index) === index) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
  }
}

if (!customElements.get('s-mini-gallery')) customElements.define('s-mini-gallery', MiniGallery);
